export default __webpack_public_path__ + "static/media/edit-blue.7e6f6bf8.svg";